module.exports = __webpack_public_path__ + "65d07b8bfe3ae89bcb8a537726da62e8.svg";